export interface TaskExportRequest {
    task_id: string;
}

export interface TaskExportResponse {
    file_name: string;
    url: string;
}

/**
 * 导出任务 Api
 */
export interface TaskExportApi {
    exportTask(data: TaskExportRequest): Promise<TaskExportResponse>;
}

export const TaskExportApi = Symbol('TaskExportApi');
